import axios from "axios";

export const state = {
    productunits: [],
};

export const getters = {
    productunits: state => state.productunits,
};

export const mutations = {
    setProductUnits(state, newValue) {
        state.productunits = newValue
    },
};

export const actions = {
    fetchUnits({ commit }) {
        axios.get('/productunits').then(res => {
            commit('setProductUnits', res.data.units)
        })
    },
};
